import { when } from 'cerebral/operators'

export default [
  when('input:remember'),
  {
    true: [
      function remember({ input }) {
        window.localStorage.setItem('loginMethod', input.loginMethod)
      }
    ],
    false: []
  },
  function determineLoginMethod({ input, state }) {
    if (input.loginMethod === 'third-party')
      return (window.location.href = state.get('client.sso.thirdPartyLoginURL'))

    state.unset('login.thirdPartyError')
    state.set('client.currentPage', 'login')
  }
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/setLoginMethod.js